import React from 'react';
import { useTranslation } from 'react-i18next';

import { IQuizFormInputGroup } from '../quiz.types';
import {
  StyledDeclarativeTitle,
  StyledQuestionBlock,
  StyledQuestionTitle,
} from '../styles';
import { QuestionInput } from './QuestionInputs';
import {
  StyledRequiredAsterisk,
  StyledRequiredCaption,
} from './styles';

type QuizStepProps = {
  group: IQuizFormInputGroup;
};

export function QuizStep({ group }: QuizStepProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div>
      {/* Declarative group title */}
      {group.isDeclarative && group.title && (
        <StyledDeclarativeTitle variant="h6">
          {group.title}
        </StyledDeclarativeTitle>
      )}

      {group.formInputs.map((input) => (
        <StyledQuestionBlock key={input.id}>
          {/* Question label */}
          <StyledQuestionTitle variant="body1">
            {input.label}
            {input.isRequired && (
              <StyledRequiredAsterisk aria-hidden="true">
                *
              </StyledRequiredAsterisk>
            )}
          </StyledQuestionTitle>
          <QuestionInput input={input} />
          <br/>
          {input.isRequired && (
            <StyledRequiredCaption variant="caption" color="textSecondary">
              {t('quiz.form.required')}
            </StyledRequiredCaption>
          )}
        </StyledQuestionBlock>
      ))}
    </div>
  );
}
